const convertHTMLObjToArrayForKpp = (htmlObj) => {
  return Object.entries(htmlObj).map(([key, html]) => {
    return { id: key, ...parseHTMLStringForKpp(html) };
  });
}

const parseHTMLStringForKpp = (htmlString) => {
  const name = (htmlString.match(/<[^>]+data-id="name"[^>]*>([^<]+)<\/[^>]+>/) || [])[1] ?? '';
  const description = (htmlString.match(/<[^>]+data-id="description"[^>]*>\s*([^<]+)/s) || [])[1]?.trim() ?? '';
  const rating = (htmlString.match(/<[^>]+data-id="ratingValue"[^>]*>([^<]+)<\/[^>]+>/) || [])[1] ?? '';
  const reviewCount = (htmlString.match(/<[^>]+data-id="reviewCount"[^>]*>([^<]+)<\/[^>]+>/) || [])[1] ?? '';
  const address = (htmlString.match(/<[^>]+data-id="address"[^>]*>([^<]+)<\/[^>]+>/) || [])[1] ?? '';
  const image = (htmlString.match(/<[^>]+srcset="([^"]+)"[^>]*>/) || [])[1] ?? '';

  return { name, description, rating, reviewCount, address, image };						
}

const generateJsonLdForKpp = (kppData, site, placeName = '') => {
  return kppData.map(item => {
    const aggregateRating = item.rating ? {
      "@type": "AggregateRating",
      ratingValue: item.rating,
      reviewCount: item.reviewCount
    } : undefined;

    const address = {
      "@type": "PostalAddress",
      addressLocality: item.address || placeName,
      addressCountry: "US"
    };

    const logo = item.image ? {
      "@type": "ImageObject",
      contentUrl: item.image
    } : undefined;
    
    return {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      additionalType: site === 'demolition' ? "https://schema.org/HomeAndConstructionBusiness" : "https://schema.org/WasteManagement",
      name: item.name,
      description: item.description,
      ...(aggregateRating && { aggregateRating }),
      address,
      ...(logo && { logo })
    };
  });
};

const formatBookingJson = (data) => {
  let newFormData = data
  if (typeof data === 'string') {
    try {
      newFormData = JSON.parse(data);
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  }
  const initialValues = [
    { key: 'wasteType', value: [+newFormData.wasteType] },
    { key: 'deliveryAddress', value: (newFormData.odf_street && newFormData.odf_street2) ? newFormData.odf_street + ', ' + newFormData.odf_street2 : ''},
    { key: 'fullFormData', value: newFormData},
  ]
  localStorage.setItem('onlineBookingData',JSON.stringify({ placeId: null, baseServiceId: "62a9f2cd61706a135071a7e3", skip: 0, limit: 21, initialValues: initialValues, finalDataForBooking: null }))
  return newFormData;
}

const manualGoogleEvents = (eventName) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: eventName
    });
  }
}

const formatData = (data) => {
  let address = data.find(element => element.key === 'fullFormData').value
  if(address) {
    address = JSON.parse(address)
    let addressObj = {}
    address.forEach(e => addressObj[e[0]] = e[1])
    const wasteType = data.find(element => element.key === 'wasteType').value
    const dumpsterSize = data.find(e => e.key === 'dumpsterSize')?.value
    const obj = {
      "odf_country": addressObj.country,
      "odf_locality": addressObj.locality,
      "odf_place_id": addressObj.place_id,
      "odf_postal_code": addressObj.postal_code,
      "odf_state": addressObj.state,
      "odf_street": addressObj.street,
      "odf_street2": addressObj.street2,
      "wasteType": wasteType,
    }
    if (dumpsterSize) {
      obj.dumpsterSize = dumpsterSize;
    }
    return obj;
  }
}

const getFormDataForStorage = () => {
  let obj = {};
  if(typeof window !== 'undefined'){ 
    const localData = JSON.parse(localStorage.getItem('onlineBookingData'));
    if(localData){
      let populatedData = {};
      if (localData.finalDataForBooking) {
        populatedData = formatData(localData.finalDataForBooking);
      } else {
        populatedData = localData.initialValues?.find(data => data.key === 'fullFormData')?.value
      }
      if (populatedData?.wasteType && populatedData?.odf_postal_code) {
        const wasteTypeValue = Array.isArray(populatedData.wasteType) ? populatedData.wasteType[0] : populatedData.wasteType;
        obj.wasteType = wasteTypeValue;
        delete populatedData.wasteType;
        delete populatedData.dumpsterSize;
        obj.addressData = { ...populatedData };
      }
    }
  }
  return obj;
}

const getInitialFormValues = () => {
  const localData = getFormDataForStorage();
  if (localData?.addressData && localData?.wasteType) {
    const allData = {
      ...localData.addressData,
      wasteType: localData.wasteType
    };
    const keyValueArray = Object.entries(allData).map(([key, value]) => ({
      key,
      value
    }));
    return keyValueArray;
  }
  return [];
}

const trackProCardsViews = (eventPrefix, className, startCounter = 0, customerView, sponsored) => {
  if (!window.dataLayer) {
    console.error("dataLayer is not available.");
    return;
  }

  const elements = document.getElementsByClassName(className);
  if (!elements || elements.length === 0) {
    return;
  }
  const viewedServiceIds = new Set(); // track each unique service card
  const viewedProIds = new Set();     // track unique pros for customer views

  if (startCounter > 0) {
    [...elements].slice(0, startCounter).forEach(el => {
      const proId = el.dataset.proid;
      if (proId) viewedProIds.add(proId);
    });
  }

  let counter = startCounter;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const proId = el.dataset.proid;
          const serviceId = el.dataset.serviceid;
          // main event — fire once per serviceId (each card)
          if (!viewedServiceIds.has(serviceId)) {
            viewedServiceIds.add(serviceId);
            counter++;

            const eventName = eventPrefix + counter;
            const eventData = {
              event: eventName,
              proid: proId,
            };
            eventData[eventName] = proId;

            window.dataLayer.push(eventData);
          }

          // customer view — fire once per proId
          if (customerView && !viewedProIds.has(proId)) {
            viewedProIds.add(proId);
            const foundIndex = viewedProIds.size;
            const eventGtaName = (sponsored ? "sponsoredProServiceVisible" : "proServiceVisible") + foundIndex;
            const eventGtaData = {
              event: eventGtaName,
              proid: proId,
            };
            eventGtaData[eventGtaName] = proId;

            window.dataLayer.push(eventGtaData);
          }

          obs.unobserve(el); // stop tracking once it has been seen
        }
      });
    },
    {
      root: null,
      threshold: 0.3, // 30% visible to trigger
    }
  );

  const elementsToProcess = [...elements].slice(startCounter);
  elementsToProcess.forEach(el => observer.observe(el));
}

const trackSimpleEvent = (eventName, proId) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: eventName,
    proid: String(proId),
    timestamp: Date.now(),
  });
};


const trackProCardsViewsOnViewport = (eventPrefix, className, startCounter = 0) => {
  if (!window.dataLayer) {
    console.error("dataLayer is not available.");
    return;
  }

  const elements = document.getElementsByClassName(className);
  if (!elements?.length) return;

  const viewed = new Set();
  let counter = startCounter;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const proId = el.dataset.proid;
          if (!viewed.has(proId)) {
            viewed.add(proId);
            counter++;

            const eventName = eventPrefix + counter;
            const eventData = {
              event: eventName,
              proid: proId,
            };
            eventData[eventName] = proId;

            window.dataLayer.push(eventData);
          }

          obs.unobserve(el);
        }
      });
    },
    {
      root: null,
      threshold: 0.3, // 30% visible
    }
  );

  const elementsToProcess = [...elements].slice(startCounter)
  if (elementsToProcess?.length > 0) {
    elementsToProcess.forEach(el => observer.observe(el));
  }
};

const trackBookingSubmission = (proId) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: 'bookingSubmission',
      proid: proId,
      'bookingSubmission': proId
    });
  }
}

const createAddressEvent = async (addressObject, proId) => {
  try {
    if (process.env.GATSBY_EVENTS_API_URL) {
      const source = window.location.origin;
      const url = window.location.href;
      let sessionId = localStorage.getItem('sessionId');
      if (!sessionId) {
        const auxCode = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2)
        localStorage.setItem('sessionId', auxCode)
        sessionId = auxCode;
      }
      const event = {
        eventType: "SC",
        eventDescription: !addressObject.hasNoCity ? "Address Selected" : "No city selected",
        eventData: {
          source,
          sessionId,
          url,
          ...addressObject,
        }
      }
      if (proId) {
        event.proId = proId;
      }

      const response = await fetch(
        `${process.env.GATSBY_EVENTS_API_URL}/events`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(event),
        }
      );
      return await response.json();
    }
    return;
  } catch (error) {
    console.error('Error creating address event:', error);
  }
}

module.exports = { convertHTMLObjToArrayForKpp, generateJsonLdForKpp, formatBookingJson, manualGoogleEvents, formatData, getFormDataForStorage, getInitialFormValues, trackProCardsViews, trackSimpleEvent, trackBookingSubmission, createAddressEvent, trackProCardsViewsOnViewport }